import { Component } from '@angular/core';
import { GoogleCalendarServiceAccountService } from 'src/app/services/google-calendar-service-account.service';
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { Router, NavigationEnd } from "@angular/router";

@Component({
  selector: 'calsoft-google-calender-excel-import',
  templateUrl: './google-calender-excel-import.component.html',
  styleUrls: ['./google-calender-excel-import.component.scss']
})
export class GoogleCalenderExcelImportComponent {

  url = '';
  sanitizedUrl = '';


 constructor(private router: Router) {
     this.url = this.router.url || '';
     this.sanitizedUrl = this.sanitizeUrl(this.url);
     this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
       this.url = this.router.url || '';
       this.sanitizedUrl = this.sanitizeUrl(this.url);
     }); }

  mapper  =  [
  { "title": "Summary", "name": "summary" },
  { "title": "Description", "name": "description" },
  { "title": "TimeZone", "name": "timeZone" },
  { "title": "StartDateTime", "name": "startDateTime" },
  { "title": "EndDateTime", "name": "endDateTime" },
  { "title": "Attendees", "name": "attendees" },
  { "title": "Start Time", "name": "startTime" },
  { "title": "End Time", "name": "endTime" }
]
    protected _onDestroy = new Subject<void>();

    sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
